module.exports = __webpack_public_path__ + "static/media/logofinal.f6b65991.png";